export default {
	sales: {
		averagePriceCurrent: 0,
		averagePriceCompare: 0,
		current: [],
		compare: [],
		currentChart: {},
		compareChart: {},
	},
	traffic: {
		current: {
			entries: [],
			welcomeTotal: 0,
			grouped: [],
			total: 0,
			groupedTotal: 0,
		},
		currentTotal: 0,
		currentChart: {},
		compare: {
			entries: [],
			welcomeTotal: 0,
			grouped: [],
			total: 0,
			groupedTotal: 0,
		},
		compareChart: {},
		builders: {},
		currentGrouped: {
			prospect: 0,
			realtor: 0,
		},
	},
	closings: {
		current: [],
		compare: [],
		currentChart: {},
		compareChart: {},
	},
	bustouts: {
		current: [],
		compare: [],
		currentChart: {},
		compareChart: {},
	},
	cancels: {
		current: [],
		compare: [],
		currentChart: {},
		compareChart: {},
	},
	starts: {
		averagePriceCurrent: 0,
		averagePriceCompare: 0,
		current: [],
		compare: [],
		currentChart: {},
		compareChart: {},
	},
	transfers: {
		current: [],
	},
	public: {
		builders: [],
		options: {
			occupations: [],
			ethnicity: [],
			exceptions: [],
		},
		neighborhoods: {},
		floorplans: [],
		elevations: [],
		salespeople: [],
		trafficSources: [],
		properties: [],
		metro: [],
		metroSub: [],
		developers: [],
		isds: [],
		lids: [],
		occupations: [],
		states: [],
		countries: [],
		subdivisions: [],
		sites: [],
		lot_types: [],
		lot_sizes: [],
		muds: [],
		land_features: [],
		land_tracts: [],
		land_feature_types: [],
		info_center_users: [],
		lot_type_groups: [],
		schools: [],
		marketing_lot_types: [],
		lot_classifications: [],
		arc_material_types: [],
		arc_materials: [],
		arc_colors: [],
	},
	models: [],
	builderSalesTotals: {},
	realtorData: {
		current: {
			offices: [],
			realtors: [],
		},
		compare: {
			offices: [],
			realtors: [],
		},
	},
	activity: [],
	recentTraffic: [],
	salespersonNeighborhoods: {},
	neighborhoodsList: [],
	exec: {
		projections: [],
		projections_takedowns: [],
		yearProjections: [],
		salesThisYear: null,
		recentActivity: [],
		inventoryStatus: {
			available: null,
			salePending: null,
			sold: null,
			offMarket: null,
		},
		yearOverYearByMonth: [{}, {}, {}],
		averageSale: {},
		averageClose: {},
		dirtVsSpecByYear: {},
		realtorInvolvedByYear: {},
		weeklyStats: {},
		lots: [],
		sales: [],
		busts: [],
		traffic: {
			individual: [],
			grouped: [],
			grouped_total: 0,
		},
		weeklyReport: {
			trafficCount: {
				grouped: 0,
				individual: 0,
				ytd: {
					grouped: 0,
					individual: 0,
				},
				ltd: {
					grouped: 0,
					individual: 0,
				},
			},
			trafficEntries: {
				ytd: {
					individual: [],
					grouped: [],
				},
			},
		},
		weeklyActivity: [],
		users: {
			salespeople: [],
			sales_managers: [],
			dev: [],
		},
		salesOpportunities: {
			count: 0,
		},
		vacantLotInventory: [],
	},
	weekly: {
		name: "",
	},
	ytdTotals: {
		lastYearSales: 0,
		lastYearBusts: 0,
		thisYearSales: 0,
		thisYearBusts: 0,
	},
	communityPerformance: [],
	users: [],
	modules: [],
	settings: {},
	arcPayload: {
		lots: [],
		floorplans: [],
		arc: {
			floorplans: [],
		},
	},
	salespersonPayload: {
		lots: {
			current: [],
			lots: [],
			allSales: [],
		},
		lot_types: [],
		lot_sizes: [],
		recentTraffic: [],
		info: [],
		models: [],
		help: "",
		noActButton: false,
		communityManagers: "",
		salespersonCompetition: {},
		arc: {
			floorplans: [],
		},
	},
	superintendentPayload: {
		lots: [],
	},
	salesManagerPayload: {
		lots: [],
		sales: [],
		help: "",
		communityManagers: "",
		weeklyActivity: [],
		overSalespeople: [],
	},
	salesTotalsByWeek: [],
	allSalesTotalsByWeek: [],
	manualSales: [],
	analytics: {},
}